import React from "react";
import './FAQ.css';

class FAQ extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">الاسئلة العامة لمقابلة السفارة و التجارب</legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <h3>
                                        هتكلم النهاردة عن كل ما يخص مقابلة السفارة و النصائح و الاسئلة المشهورة
                                        <br/>
                                        = ازاى احجز ميعاد في السفارة ؟
                                        <br/>
                                        هتلاقى الإجابة في <a href='../embassyinterview/details'>البوست</a> دة
                                        <br/>
                                        = لغة المحادثة فى الانترفيو ؟
                                        <br/>
                                        على حسب انت رايح تدرس بإنهى لغة
                                        <br/>
                                        يعنى لو هتدرس بالانجليزى فهيبقا الانترفيو بالانجليزى و لو بتعرف المانى فهيسألك و هيتكلم معاك و ممكن يتكلم عربى
                                        <br/>
                                        لو هتدرس بالالمانى فأكيد هيسألك بالألمانى و لو بتتكلم انجليزى فهيتكلم انجليزى برضه و ممكن عربى
                                        <br/>
                                        = مدة الانترفيو ؟
                                        <br/>
                                        مالهاش مدة لان ممكن تبقا نص ساعة و ممكن تبقا اقل و ممكن تبقا اعلى فـ انت وحظك
                                        <br/>
                                        = الورق المطلوب ؟
                                        <br/>
                                        على حسب انت رايح فيزا ايه .. و هتلاقى في البوست المثبت كل فيزا و متطلباتها
                                        <br/>
                                        = لازم في الانترفيو ادخل و ورقى كامل ؟
                                        <br/>
                                        لاء مش لازم و ليك انك تعمل استكمال للأوراق اللى نقصاك
                                        <br/>
                                        = مدة فترة الاستكمال و مواعيد الاستكمال ؟
                                        <br/>
                                        يفضل متزيدش عن شهر او شهر ونص يفضل فالوقت الحالى ان تدخل بكل ورقك و بالتحديد يكون معاك قبول الجامعة و دى اهم ورقة
                                        <br/>
                                        و مواعيد الاستكمال من الأحد للأربع من الساعة
                                        <br/>
                                        1 ل 3 م
                                        <br/>
                                        ممكن تتغير من وقت للتانى فيفضل تسأل الموظف
                                        <br/>
                                        و ممكن تعمل استكمال بالايميل بس يفضل تسلم ليهم الورق بنفسك
                                        <br/>
                                        = بعض التجارب و النصائح
                                        <br/>
                                        <div className='lft'>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/458271427884916/'>facebook.com/../permalink/458271427884916</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/453851501660242/'>facebook.com/../permalink/453851501660242</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/440492102996182/'>facebook.com/../permalink/440492102996182</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/476800239365368/'>facebook.com/../permalink/476800239365368</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/319619915083402/'>facebook.com/../permalink/319619915083402</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/442262499485809/'>facebook.com/../permalink/442262499485809</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/447941512251241/'>facebook.com/../permalink/447941512251241</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/442677872777605/'>facebook.com/../permalink/442677872777605</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/524509141261144/'>facebook.com/../permalink/524509141261144</a>
                                        </div>
                                        <br/>
                                        = الأسئلة المشهورة في السفارة ؟
                                        <br/>
                                        سلسلة فيديوهات ل أ/ محمد شحاتة عن مقابلة السفارة و الأسئلة المشهورة
                                        عشر نصائح ذهبية عشان <a target='_blank' rel='noreferrer' href='https://youtu.be/_Uj8ztBnAmU'>مقابلة السفارة الالمانية</a>
                                        <br/>
                                        كيف تجتاز مقابلة السفارة الألمانية جزئين
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://youtu.be/Njp4bJvdpxE'>youtu.be/Njp4bJvdpxE</a>
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://youtu.be/YFfg0ft5hBE'>youtu.be/YFfg0ft5hBE</a>
                                        <br/>
                                        <br/>
                                        = بعض الأسئلة المشهورة في الانترفيو
                                        <br/>
                                        مش لازم تتسأل كلهم
                                        <br/>
                                        <br/>
                                        1. Stellen Sie sich bitte vor?
                                        <br/>
                                        عرف نفسك ، اسمك وسنك و دراستك السابقة وهكذا؟
                                        <br/>
                                        <br/>
                                        2. Was möchten Sie in Deutschland studieren und warum haben Sie das Studium gewählt?
                                        <br/>
                                        ناوي تدرس اي؟ و ليه اختارت التخصص ده (خطاب التحفيز)
                                        <br/>
                                        <br/>
                                        3. Was wissen Sie über das Studium (Medizin, Informatik, Maschinenbau)?
                                        <br/>
                                        اتكلم شوية عن مجالك ؟ اختراعات و تظريات و افكار و هكذا!
                                        <br/>
                                        <br/>
                                        4. Wer wird ihr Studium finanzieren?
                                        <br/>
                                        مين الي هيمولك ؟ طبعاً اول سنه حساب مغلق و تاني سنه مساعدات من والدي!
                                        <br/>
                                        <br/>
                                        5. Was haben Sie nach dem Ende ihres Studiums vor?
                                        <br/>
                                        هتخلص دراسة ، هتعمل اي؟
                                        <br/>
                                        <br/>
                                        6. Was wissen über Deutschland? Was wissen Sie über die Stadt ihrer Zulassung?
                                        <br/>
                                        ماذا تعرف عن ألمانيا ؟ ماذا تعرف عن مدينة قبولك ؟
                                        <br/>
                                        <br/>
                                        7. Woher wissen Sie das?
                                        <br/>
                                        عرفت المانيا ازاي ؟
                                        <br/>
                                        <br/>
                                        8. Wie viele Geschwister haben Sie und was arbeiten sie?
                                        <br/>
                                        كم شقيق و بيشتغلوا ايه؟
                                        <br/>
                                        <br/>
                                        9. Was macht ihr/e Vater/ Mutter beruflich?
                                        <br/>
                                        وظائف والديك
                                        <br/>
                                        <br/>
                                        10. Wie viel verdient er/ sie monatlich?
                                        <br/>
                                        بياخدوا كام في الشهر؟
                                        <br/>
                                        <br/>
                                        11. Wie viele Tage/ Monate hat ein Jahr/ Monat?
                                        <br/>
                                        كام يوم عمل ليهم؟
                                        <br/>
                                        <br/>
                                        12. Seit wann und wo lernen Sie Deutsch?
                                        <br/>
                                        متى و فين اتعلمت الالماني؟
                                        <br/>
                                        <br/>
                                        13. Wie viele Stunden lernen Sie Deutsch am Tag?
                                        <br/>
                                        كام ساعة دراسة الماني في اليوم؟
                                        <br/>
                                        <br/>
                                        15. Wo werden Sie in Deutschland wohnen?
                                        <br/>
                                        هتعيش فين في المانيا ؟ لازم تعرف عن مدينتك كويس و الولاية التابعه ليها!
                                        <br/>
                                        <br/>
                                        16. Haben Sie Freunde oder Verwandte in Deutschland und wenn ja was machen sie?
                                        <br/>
                                        ليك اصحاب و اقارب في المانيا , و بيعملوا اي؟
                                        <br/>
                                        <br/>
                                        17. Waren Sie schonmal im Ausland und wenn ja wo und warum?
                                        <br/>
                                        سافرت قبل كده للخارج فين و امتى؟!
                                        <br/>
                                        <br/>
                                        18. Wie viel Protzent haben Sie in ihrem Abitur bekommen und wann haben Sie es gemacht?
                                        <br/>
                                        درجات في الثانوية و امتى واخدها؟
                                        <br/>
                                        <br/>
                                        19. Wie lange möchten Sie in Deutschland bleiben?
                                        <br/>
                                        ناوي تقعد لأمتى ؟
                                        <br/>
                                        <br/>
                                        20. Wie haben Sie ihre Zulassung bekommen?
                                        <br/>
                                        حصلت ازاي على موافقة
                                        <br/>
                                        <br/>
                                        21. Was machen Sie in ihrer Freizeit?
                                        <br/>
                                        بتقضي وقتك ازاي؟
                                        <br/>
                                        <br/>
                                        22. Wer wird Sie in Deutschland vom Flughafen abholen?
                                        <br/>
                                        مين هيستقبلك في ألمانيا؟
                                        <br/>
                                        <br/>
                                        23. Was werden Sie machen, wenn Sie kein Visum bekommen?
                                        <br/>
                                        ماذا ستفعل إذا لم تحصل على تأشيرة؟
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default FAQ;
